import { sqlApi } from "./api"

export const getTradesByIPService = () => {
  return sqlApi.get("/index.php?method=fetchTrades")
}

export const createSharingLogicService = (_qstring: string) => {
  return sqlApi.get("/index.php?method=fetchTrades&" + _qstring)
}

export const fetchCommissionLogicService = (_login: string, _date: string) => {
  return sqlApi.get(
    `/index.php?method=fetchCommission&Login=${_login}&date=${_date}`
  )
}
